export default __webpack_public_path__ + "static/media/T-box-slider2.d6ea96be.jpg";